import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataShareService {

  public newTitle = '';
  private messageSource = new BehaviorSubject(this.newTitle);
  currentMessage = this.messageSource.asObservable();

  constructor() { }

  public changeMessage(message: string) {
    this.messageSource.next(message);
  }
}
